module.exports = __webpack_public_path__ + "img/empreendimento-logo-28.75709d79.png";